(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-section"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  const section = document.querySelector('.oo-pdp');
  if (!section) return;

  // ── State ──────────────────────────────────────────────
  let state = {
    mode: 'subscribe',          // 'subscribe' | 'onetime'
    variantId: null,
    variantPrice: 0,            // in cents
    variantCompare: 0,          // in cents
    qty: 1,
    perUnitPrice: 0,            // in cents (from selected pack)
    sellingPlanId: null,
    subDiscount: 0.20           // fallback if no selling plan data
  };

  // ── Element refs ──────────────────────────────────────
  const els = {
    todayPrice:       section.querySelector('#oo-today-price'),
    origPrice:        section.querySelector('#oo-orig-price'),
    savings:          section.querySelector('#oo-savings'),
    togSub:           section.querySelector('#oo-tog-sub'),
    togOne:           section.querySelector('#oo-tog-one'),
    freqWrap:         section.querySelector('#oo-freq-wrap'),
    freqSelect:       section.querySelector('#oo-freq-select, #oo-freq-select-fallback'),
    giftBox:          section.querySelector('#oo-gift-box'),
    sellingPlanInput: section.querySelector('#oo-selling-plan-input'),
    qtyInput:         section.querySelector('#oo-qty-input'),
    variantInput:     section.querySelector('#oo-variant-id'),
    atcBtn:           section.querySelector('#oo-atc-btn'),
    form:             section.querySelector('#oo-product-form'),
    sizeLabels:       section.querySelectorAll('.oo-size-btn'),
    qtyCards:         section.querySelectorAll('.oo-qty-card'),
    thumbs:           section.querySelectorAll('.oo-thumb'),
    mainImg:          section.querySelector('#oo-main-img-tag'),
  };

  // ── Init ──────────────────────────────────────────────
  function init() {
    // Grab initial variant price from first size btn
    const firstSize = section.querySelector('.oo-size-btn');
    if (firstSize) {
      state.variantId      = firstSize.dataset.variantId;
      state.variantPrice   = parseInt(firstSize.dataset.price, 10);
      state.variantCompare = parseInt(firstSize.dataset.compare, 10);
      if (els.variantInput) els.variantInput.value = state.variantId;
    }

    // Grab initial pack price
    const firstPack = section.querySelector('.oo-qty-card');
    if (firstPack) {
      state.qty          = parseInt(firstPack.dataset.qty, 10);
      state.perUnitPrice = parseInt(firstPack.dataset.perUnitPrice, 10);
    }

    // Grab first selling plan
    if (els.freqSelect) {
      const firstOpt = els.freqSelect.querySelector('option');
      if (firstOpt) {
        state.sellingPlanId = firstOpt.value;
        const disc = firstOpt.dataset.discount;
        if (disc) state.subDiscount = parseFloat(disc) / 100;
      }
    }

    refreshPrices();
    bindEvents();
  }

  // ── Price engine ──────────────────────────────────────
  function refreshPrices() {
    // Use per-unit price from pack card if set, else fall back to variant price
    let unitCents = state.perUnitPrice > 0 ? state.perUnitPrice : state.variantPrice;
    let compareCents = state.variantCompare > 0 ? state.variantCompare : unitCents;

    if (state.mode === 'subscribe') {
      unitCents = Math.round(unitCents * (1 - state.subDiscount));
    }

    const totalCents    = unitCents * state.qty;
    const totalCompare  = compareCents * state.qty;
    const savedCents    = totalCompare - totalCents;

    if (els.todayPrice) els.todayPrice.textContent = formatMoney(totalCents);
    if (els.origPrice)  els.origPrice.textContent  = formatMoney(totalCompare);
    if (els.savings)    els.savings.textContent    = formatMoney(savedCents > 0 ? savedCents : 0);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ── Event bindings ────────────────────────────────────
  function bindEvents() {

    // Purchase mode toggle
    [els.togSub, els.togOne].forEach(btn => {
      if (!btn) return;
      btn.addEventListener('click', () => {
        const m = btn.dataset.mode;
        setMode(m);
      });
    });

    // Frequency select
    if (els.freqSelect) {
      els.freqSelect.addEventListener('change', () => {
        const opt = els.freqSelect.selectedOptions[0];
        if (opt) {
          state.sellingPlanId = opt.dataset.planId || opt.value;
          const disc = opt.dataset.discount;
          if (disc) state.subDiscount = parseFloat(disc) / 100;
          if (els.sellingPlanInput) els.sellingPlanInput.value = state.sellingPlanId;
          refreshPrices();
        }
      });
    }

    // Size selection
    els.sizeLabels.forEach(label => {
      label.addEventListener('click', () => {
        els.sizeLabels.forEach(l => l.classList.remove('is-selected'));
        label.classList.add('is-selected');
        state.variantId      = label.dataset.variantId;
        state.variantPrice   = parseInt(label.dataset.price, 10);
        state.variantCompare = parseInt(label.dataset.compare, 10);
        if (els.variantInput) els.variantInput.value = state.variantId;
        refreshPrices();
      });
    });

    // Quantity pack selection
    els.qtyCards.forEach(card => {
      card.addEventListener('click', () => {
        els.qtyCards.forEach(c => c.classList.remove('is-selected'));
        card.classList.add('is-selected');
        state.qty          = parseInt(card.dataset.qty, 10);
        state.perUnitPrice = parseInt(card.dataset.perUnitPrice, 10);
        if (els.qtyInput) els.qtyInput.value = state.qty;
        refreshPrices();
      });
    });

    // Image thumbnails
    els.thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        els.thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (els.mainImg && thumb.dataset.imgUrl) {
          els.mainImg.classList.add('is-loading');
          const img = new Image();
          img.src = thumb.dataset.imgUrl;
          img.onload = () => {
            els.mainImg.src = thumb.dataset.imgUrl;
            els.mainImg.classList.remove('is-loading');
          };
        }
      });
    });

    // Form submit — AJAX cart add
    if (els.form) {
      els.form.addEventListener('submit', handleFormSubmit);
    }
  }

  // ── Mode switch ───────────────────────────────────────
  function setMode(m) {
    state.mode = m;
    const isSub = m === 'subscribe';

    // Toggle buttons
    if (els.togSub) {
      els.togSub.classList.toggle('is-active', isSub);
      els.togSub.setAttribute('aria-pressed', isSub.toString());
    }
    if (els.togOne) {
      els.togOne.classList.toggle('is-active', !isSub);
      els.togOne.setAttribute('aria-pressed', (!isSub).toString());
    }

    // Show/hide freq + gift
    if (els.freqWrap) els.freqWrap.classList.toggle('is-hidden', !isSub);
    if (els.giftBox)  els.giftBox.classList.toggle('is-hidden', !isSub);

    // Selling plan input
    if (els.sellingPlanInput) {
      if (isSub) {
        els.sellingPlanInput.value   = state.sellingPlanId || '';
        els.sellingPlanInput.disabled = false;
      } else {
        els.sellingPlanInput.value   = '';
        els.sellingPlanInput.disabled = true;
      }
    }

    refreshPrices();
  }

  // ── AJAX cart add ─────────────────────────────────────
  function handleFormSubmit(e) {
    e.preventDefault();

    const btn = els.atcBtn;
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    const formData = new FormData(els.form);

    // Remove disabled selling_plan field if one-time
    if (state.mode === 'onetime') {
      formData.delete('selling_plan');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(res => {
      if (!res.ok) throw new Error('Cart add failed');
      return res.json();
    })
    .then(() => {
      // Dispatch event for cart drawer / mini-cart integration
      document.dispatchEvent(new CustomEvent('cart:item-added', {
        detail: { variantId: state.variantId, qty: state.qty }
      }));

      // Visual feedback
      const btnText = btn.querySelector('.oo-atc-btn__text');
      if (btnText) btnText.textContent = '✓ Added to Cart';
      btn.style.background = '#1A7A50';

      setTimeout(() => {
        if (btnText) btnText.textContent = 'Add to Cart';
        btn.style.background = '';
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }, 2800);

      // Update cart count badge if your theme uses one
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const badge = document.querySelector('.cart-count, [data-cart-count]');
          if (badge) badge.textContent = cart.item_count;
        });
    })
    .catch(err => {
      console.error('[oonunu PDP]', err);
      btn.disabled = false;
      btn.classList.remove('is-loading');
      alert('Something went wrong. Please try again.');
    });
  }

  init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, currentObserver) => {
        this.headerBounds = entries[0].intersectionRect;
        currentObserver.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
